
import { computed, defineComponent, ref, toRef, watch } from "vue";
import { TranslationService } from "@/core/services/TranslationService";
import VZModal from "@/components/content/VZModal.vue";
import { FormatMethods } from "@/helpers/data-format";
import { DocumentApi } from "@/services/api/Document.service";
interface ResultItem {
  fileId: string;
}
export default defineComponent({
  name: "form-Phone-modal",
  components: { VZModal },
  props: {
    //phone: { type: Array as () => Array<IUser> },
    audioId: { type: Object, default: null },
    id: { type: String, default: "kt_user_Phone" },
    showDialog: { type: Boolean, default: false },
  },
  emits: ["close-detail"],
  setup(props, { emit }) {
    const t = (key: string) => {
      return TranslationService.translate(key);
    };
    const audioId = toRef(props, "audioId");
    const showDialog = toRef(props, "showDialog");

    let result = ref<Array<ResultItem>>([]);
    const fetchData = async () => {
      try {
        result.value = await DocumentApi.getInstance().audioFileList(
          audioId.value.webId
        );
        for (let i = 0; i < result.value.length; i++) {
          let response = await DocumentApi.getInstance().fetchAudioWithMetaData(
            result.value[i].fileId
          );
          const { data } = response;

          const uint8ArrayData = new Uint8Array(data);
          const text = new TextDecoder().decode(uint8ArrayData);
          let decodeData = JSON.parse(text);
          result.value[i].fileId = decodeData.fileUrl;
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    watch(showDialog, async (newShowDialog) => {
      if (newShowDialog && audioId.value) {
        await fetchData();
      }
    });

    const format = computed(() => {
      return FormatMethods;
    });
    const close = () => {
      emit("close-detail");
    };
    return {
      t,
      close,
      format,
      result,
      // eslint-disable-next-line vue/no-dupe-keys
      audioId,
    };
  },
});
